exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag[data-v-7404f160]{width:32px;height:32px;display:inline-block;vertical-align:middle}", ""]);

// exports
